module.exports = __webpack_public_path__ + "assets/img/btn-view-f2e91c46.png";